import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import eyeIcon from "../../assests/eyeIcon.svg";
import search from "../../assests/search.svg";
import leftArrow from "../../assests/leftArrow.svg";
import filter from "../../assests/filterIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import "./UsersRoleList.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import emotions7 from "../../assests/emotions7.svg";
import LoadingSpinner from "../Loading/component";

export const UsersroleList = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const addUser = () => navigate("/createuser");
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);
  const arrowClick = () => navigate("/");

  return (
    <div className="users-roles-container">
      <Sidebar />
      {props.loading ? (
          <LoadingSpinner />
        ) : (
      <div className="users-roles-content">
       
       
       
           {props.error && (
            <div className="error-message-top">
              {props.error}
              <button 
                className="error-close-btn"
                onClick={() => props.onDismissError()}
              >
                &times;
              </button>
            </div>
          )}
            <div className="users-roles-header">
              <button onClick={arrowClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Users & Roles</h1>
            </div>

            <div className="users-roles-controls">
              <div className="user-roles-search-container">
                <input
                  type="search"
                  placeholder="Search by Full Name / Mobile Number"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onChange={(e) => props.Search(e.target.value)}
                />
                <img
                  src={search}
                  alt="Search"
                  className={`user-roles-search-icon ${isFocused ? "hidden" : ""}`}
                />
              </div>
              
              <Button
                onClick={addUser}
                className="add-button"
                variant="primary"
              >
                + Add User
              </Button>
            </div>

            <div className="table-wrapper" ref={props.tableContainerRef}>
              <Table responsive>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Full Name</th>
                    <th>User ID</th>
                    <th>Mobile Number</th>
                    <th className="filter-columnrole">
                      Role
                      <Dropdown>
                        <Dropdown.Toggle variant="link" className="filter-toggle">
                          <img src={filter} alt="Filter" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {props.roleList?.map((el, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={(e) => props.handleUpdateUserRole(e, el.id)}
                            >
                              {el.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </th>
                    <th className="filter-columnstatus">
                      Status
                      <Dropdown>
                        <Dropdown.Toggle variant="link" className="filter-toggle">
                          <img src={filter} alt="Filter" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => props.handleActiveClick()}>
                            Active
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => props.handleInactiveClick()}>
                            Inactive
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {props.filteredUserListTable?.length > 0 ? (
                    props.filteredUserListTable.map((item, index) => (
                      <tr key={item.id} className="user-role-view">
                        <td>{index + 1}</td>
                        <td>{item.full_name}</td>
                        <td>{item.id}</td>
                        <td>{item.mobile}</td>
                        <td>{item.user_role}</td>
                        <td>
                          <span className={`users-roles-status-badge ${item.status !== "active" ? "deleted" : ""}`}>
                            {item.status === "active" ? "Active" : "Deleted"}
                          </span>
                        </td>
                        <td>
                          <Link to={`/users/userlist/${item.id}`}>
                            <img src={eyeIcon} alt="View" className="user-role-eye-icon" />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <div className="no-user-results">
                <img src={emotions7} alt="No users found" />
                <p>{props.error ? "Error loading users" : "No User Found"}</p>
              </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
       
       
      </div>
       )}
    </div>
  );
};